export default {
    UNKNOWN_FINGER: "UNKNOWN_FINGER",
    RIGHT_LITTLE: "RIGHT_LITTLE",
    RIGHT_RING: "RIGHT_RING",
    RIGHT_MIDDLE: "RIGHT_MIDDLE",
    RIGHT_INDEX: "RIGHT_INDEX",
    RIGHT_THUMB: "RIGHT_THUMB",
    LEFT_THUMB: "LEFT_THUMB",
    LEFT_INDEX: "LEFT_INDEX",
    LEFT_MIDDLE: "LEFT_MIDDLE",
    LEFT_RING: "LEFT_RING",
    LEFT_LITTLE: "LEFT_LITTLE"
};